module.exports = __webpack_public_path__ + "static/media/share.fcc3fb9b.svg";